import listConstants from "../../list/constants";
import poiConstants from "../../pois/constants";
import actions from "./actions";
import mobile from "./mobile";

const constants = Object.assign({},
  actions,
  listConstants,
  poiConstants,
  mobile,
);

export default constants;



// WEBPACK FOOTER //
// ./assets/shared/constants/index.js